import React from 'react';

const ChevronIcon = () => (
  <svg className="chevron" viewBox="0 0 16 16" fill="none">
    <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

/**
 * SelectWrap — native <select> with chevron arrow
 * Props: value, onChange, options = [{value, label}], badge (number)
 */
export function SelectWrap({ value, onChange, options = [], badge, style }) {
  const select = (
    <div className="select-wrap" style={style}>
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <ChevronIcon />
    </div>
  );

  if (badge) {
    return (
      <div className="badge-wrap">
        {select}
        {badge > 0 && <span className="badge-count">{badge > 99 ? '99+' : badge}</span>}
      </div>
    );
  }
  return select;
}

/**
 * DateInput — native date input styled to match design system
 */
export function DateInput({ value, onChange, title, style }) {
  return (
    <input
      className="date-input"
      type="date"
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      title={title}
      style={style}
    />
  );
}

/**
 * SearchBar
 */
export function SearchBar({ value, onChange, placeholder }) {
  return (
    <input
      className="search-input"
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || 'Rechercher…'}
    />
  );
}
